import { render, staticRenderFns } from "./MFARequiredPage.vue?vue&type=template&id=02055bcf&scoped=true&"
import script from "./MFARequiredPage.vue?vue&type=script&lang=ts&"
export * from "./MFARequiredPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02055bcf",
  null
  
)

export default component.exports